const columnDocumentType = [
  {
    title: "No.",
    scopedSlots: { customRender: "stt" },
    width: 50,
    align: "center",
  },
  {
    title: "Code",
    dataIndex: "code",
    scopedSlots: { customRender: "code" },
    sorter: (documentTypeA, documentTypeB) => {
      var codeA = documentTypeA.code.toUpperCase();
      var codeB = documentTypeB.code.toUpperCase();
      return codeA.localeCompare(codeB);
    },
    width: 120,
  },
  {
    title: "Title",
    dataIndex: "title",
    scopedSlots: { customRender: "title" },
    sorter: (documentTypeA, documentTypeB) => {
      var codeA = documentTypeA.title.toUpperCase();
      var codeB = documentTypeB.title.toUpperCase();
      return codeA.localeCompare(codeB);
    },
    width: 300,
  },

  {
    title: "Created at",
    dataIndex: "createdAt",
    scopedSlots: { customRender: "createdAt" },
    width: 160,
  },
  {
    title: "Updated at",
    dataIndex: "updatedAt",
    scopedSlots: { customRender: "updatedAt" },
    width: 160,
  },
  {
    title: "",
    dataIndex: "action",
    scopedSlots: { customRender: "action" },
    width: 15,
  },
];

export { columnDocumentType };
